import AutoPilotScheduleForm from '../../../components/AutoPilotScheduleForm';
import PendingRewrites from '../../../components/PendingRewrites';

// Thin wrapper around the existing AutoPilotScheduleForm component, which
// already renders its own card with the section header / feature gating /
// Pro tier upsell. Lives here so it can be a peer of the other settings
// sections in the rail. The auto-rewrite approval queue (C1) renders beneath
// the schedule — it self-hides when the user doesn't have AutoPilot.
export default function AutoPilotSection({ domain }) {
  return (
    <div className="space-y-5">
      <AutoPilotScheduleForm domain={domain} />
      <PendingRewrites domain={domain} />
    </div>
  );
}
